<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#user-add-s"></use></svg>
  Opret bruger med invitation til OK-app
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<form [formGroup]="userFormGroup" (ngSubmit)="save()">
  <mat-dialog-content>
    <div class="feedback-dialog-container">
      <ok-feedback-info>
        <div>
          <strong>Info omkring oprettelse</strong>
          <br />
          Brugeren modtager en sms med onboarding flow til appen
        </div>
      </ok-feedback-info>
    </div>
    <div class="form-row form-row__full-width">
      <adm-org-typeahead
        [initialId]="data.organization ? data.organization.id : undefined"
        [resetTrigger]="resetOrgTrigger()"
        (itemSelected)="organizationSelected($event)"
        (clearTypeAhead)="resetOrganization()" />
    </div>
    <div class="form-row">
      @let selectedDepartment = userFormGroup.controls.department.value;
      <adm-dep-typeahead
        [organizationId]="userFormGroup.controls.organization.value?.id ?? null"
        [departmentId]="selectedDepartment ? selectedDepartment.id.toString() : null"
        [disabled]="departmentsDisabled()"
        (itemSelected)="departmentSelected($event)"
        [resetTrigger]="resetDepartmentTrigger()" />
    </div>
    <div class="form-row">
      <h2 class="form-headline">Har brugeren firmabil?</h2>
      <mat-radio-group formControlName="userHasOrganizationCar" name="userHasOrganizationCar" class="padding--top-none">
        <mat-radio-button [value]="true">
          <span>Ja</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span>Nej</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Vælg adgangsgrupper</mat-label>
        <mat-select
          required
          [formControl]="userFormGroup.controls.selectedAccessGroups"
          multiple
          [compareWith]="compareObjects"
          okCustomDropDownArrowDirective>
          <mat-select-trigger>
            {{ userFormGroup.controls.selectedAccessGroups.value[0]?.name || '' }}
            @if (userFormGroup.controls.selectedAccessGroups.value.length > 1) {
              <span class="example-additional-selection">
                (+{{ userFormGroup.controls.selectedAccessGroups.value.length - 1 }}
                {{ userFormGroup.controls.selectedAccessGroups.value.length === 2 ? 'mere' : 'flere' }})
              </span>
            }
          </mat-select-trigger>
          @for (accessGroup of accessGroups$ | async; track accessGroup) {
            <mat-option [value]="accessGroup">{{ accessGroup.name }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>

    @if (userFormGroup.controls.selectedAccessGroups.value.length > 0) {
      <div class="form-row">
        <div class="form-row">
          <mat-label>Adgangstype</mat-label>
          <mat-radio-group formControlName="accessType">
            @for (genType of userAccessType | enumToArray | translateChargingUserCreationAccessTypeEnum; track genType.index) {
              <div>
                <mat-radio-button [value]="genType.index">
                  <span [class.bold]="userFormGroup.controls.accessType.value === genType.index">{{ genType.name }}</span>
                </mat-radio-button>
              </div>
            }
          </mat-radio-group>
        </div>
      </div>
    }

    @if (
      userFormGroup.controls.selectedAccessGroups.value.length > 0 && userFormGroup.controls.accessType.value === userAccessType.TimeLimit
    ) {
      <div class="form-row">
        <mat-form-field>
          <mat-label>Tidsbegrænset periode</mat-label>

          <mat-date-range-input [min]="minDate" [rangePicker]="picker" (click)="picker.open()">
            <input formControlName="timeFrom" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
            <input formControlName="timeTo" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    }

    <ng-container>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Navn</mat-label>
          <input matInput placeholder="Navn på brugeren" maxlength="75" formControlName="name" required value="" />
          @if (userFormGroup.controls.name.invalid) {
            <mat-error>Indtast venligst navn</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field>
          <mat-label>ID</mat-label>
          <input matInput placeholder="ID for brugeren" maxlength="100" formControlName="alias" />
          @if (userFormGroup.controls.alias.invalid && userFormGroup.controls.alias.hasError('maxlength')) {
            <mat-error> ID må maksimalt være 100 tegn </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <div class="grid-cols">
          <adm-country-code-selector [formItem]="userFormGroup.controls.countryCode" />
          <adm-phone-number-input
            [label]="'Mobilnummer'"
            [formItem]="userFormGroup.controls.phoneNumber"
            [countryCode]="userFormGroup.controls.countryCode" />
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button mat-dialog-close>Annuller</button>
    <button class="actions__button" type="submit" mat-flat-button color="primary" [disabled]="userFormGroup.invalid">Gem</button>
  </mat-dialog-actions>
</form>
